"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Chip_1 = __importDefault(require("@mui/material/Chip"));
function default_1() {
    const roomImg = (0, react_redux_1.useSelector)((state) => state.roomData.img_url);
    const leaderId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const isManager = leaderId === whoAmI.id || whoAmI.is_admin;
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const handleManagerSettingClick = () => (window.location.href = `/room/commission-update/${roomId}`);
    const title = (0, react_redux_1.useSelector)((state) => state.roomData.title);
    const tagsArr = (0, react_redux_1.useSelector)((state) => state.roomData.tag);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
            backgroundColor: 'white',
        } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(roomImg), css: { aspectRatio: maxWidth768 ? '3 / 2' : '20 / 9', width: '100%', objectFit: 'cover' } }), isManager && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '60px',
                    height: '60px',
                    borderRadius: '30px',
                    border: '1px solid #fff',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    color: 'rgba(0, 0, 0, 0.8)',
                    textAlign: 'center',
                    cursor: 'pointer',
                }, onClick: handleManagerSettingClick }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '2px 0', fontSize: '13px' } }, { children: t('수정') })), (0, jsx_runtime_1.jsx)(svgs_1.SettingIconSvg, { css: { width: '24px', height: '24px' } })] }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    padding: '14px 16px',
                    lineHeight: '24px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: 'rgba(0, 0, 0, 0.8)',
                    wordBreak: 'break-all',
                } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/payform_gold_card.webp`, css: { width: '24px', height: '15px', margin: '0 6px -2px 0' } }), `[${t('커미션 타입')}] ${title}`] })), Boolean(tagsArr.length) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '0 16px 14px' } }, { children: tagsArr.map((tag, idx) => ((0, jsx_runtime_1.jsx)(Chip_1.default, { label: `#${tag}`, onClick: () => (window.location.href = `/room/search?keyword=${tag}`), sx: {
                        height: '28px',
                        borderRadius: '6px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        fontSize: '15px',
                        color: 'rgba(0, 0, 0, 0.8)',
                        backgroundColor: 'white !important',
                        '&:active': { boxShadow: 'none' },
                        '.MuiChip-label': { padding: '0 10px' },
                    } }, `commission_tag_${tag.substring(0, 5)}_${idx}`))) })))] })));
}
exports.default = default_1;
